export default "__VITE_ASSET__651acc24__"